import React from 'react';
import LeftForm from '../../Components/Forms/LeftForm';
import RightTable from '../../Components/Tables/RightTable';
import TruckForm from '../../Components/Forms/LeftFormInputs';

const columns = [
  [
    {
      Header: 'Nom',
      accessor: 'name',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Coché si disponible',
      accessor: 'available',
      inputType: 'checkbox',
      filterable: false,
      Cell: row => {
        return (
          <div className="bool">
            {row.original[row.column.id] ? 'Oui' : 'Non'}
          </div>
        );
      },
    },
    {
      Header: 'Notes',
      accessor: 'note',
      inputType: 'textarea',
    },
  ],
];

const Trucks = () => (
  <React.Fragment>
    <LeftForm title="Créer un nouveau véhicule" model="trucks">
      <TruckForm model="trucks" columns={columns} />
    </LeftForm>
    <RightTable
      title="Liste de véhicules"
      model="trucks"
      columns={columns[0]}
    />
  </React.Fragment>
);

export default Trucks;
